import { render, staticRenderFns } from "./treatmentsFilter.vue?vue&type=template&id=f30f14c8&scoped=true"
import script from "./treatmentsFilter.vue?vue&type=script&lang=js"
export * from "./treatmentsFilter.vue?vue&type=script&lang=js"
import style0 from "./treatmentsFilter.vue?vue&type=style&index=0&id=f30f14c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30f14c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CrossSalonDialog: require('/salonhomepage/client/components/CrossSalonDialog.vue').default})
